export default __webpack_public_path__ + "static/media/MercaZMedellinGuayabal.27ff377f.geojson";